// extracted by mini-css-extract-plugin
export default {"buttonClass":"AddNewExpenseButton_buttonClass__eNuM5","button":"AddNewExpenseButton_button__0iw-F"};